<template>
    <div v-if="games.length" class="flex flex-col">
        <games-section
            :games="games"
            class="flex-grow pt-32"
            title-class="text-4xl"
        ></games-section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import GamesSection from "../components/GamesSection";

export default {
    name: "games",

    components: { GamesSection },

    created() {
        this.$store.dispatch("FETCH_GAMES");
    },

    computed: {
        ...mapState(["games"])
    }
};
</script>
